import { createBannersEndPoints } from '../../services/BannersService';
import { createSliceState } from '../serverState';
import { SliceCreator, BannersSlice } from '../store.types';

const createBannersSlice: SliceCreator<BannersSlice> = (set, get) => ({
  ...createSliceState(() => createBannersEndPoints(set, get)),
  upsert: {
    currentId: null,
  },
  deletion: {
    currentId: null,
  },
  selectedBanner: null,
});

export default createBannersSlice;
